/*
 * Copyright (c) 2017 Datarista, Inc.
 */

import { Map, List, Record } from 'immutable';
import { actionTypes as authActionTypes } from '../actions/authentication';
import { actionTypes as userActionTypes } from '../actions/user';
import { actionTypes as cpActionTypes } from '../actions/customerPortal';

export const userList = new Map({
  users: new List(),
  userTypes: new List(),
});

export const User = new Record(
  {
    id: 0,
    email: '',
    userTypeId: 0,
    firstName: '',
    lastName: '',
    phone: null,
    accountId: 0,
    status: 0,
    isPrimary: false,
    portalAccountId: 0,
    lastLoginDate: null,
    createdBy: 0,
    createdOn: '',
    updatedBy: 0,
    updatedOn: '',
  },
  'User'
);

export const UserType = new Record(
  {
    id: 3,
    description: ' ',
  },
  'UserType'
);

export const UserInvite = new Record(
  {
    isSecond: false,
    hasSecond: false,
    firstName: null,
    lastName: null,
  },
  'userInviteForm'
);

const userListInitialState = userList;
const userInitialState = new User();
const UserInviteInitialState = new UserInvite();

export function userAuthReducer(state = userInitialState, action) {
  switch (action.type) {
    case authActionTypes.AUTH_LOGIN_SUCCESS:
    case authActionTypes.AUTH_REFRESH_SUCCESS:
    case authActionTypes.AUTH_CHECK_SUCCESS:
    case userActionTypes.USER_EDIT_SUCCESS:
    case cpActionTypes.UPDATE_ACCOUNT_USER_SUCCESS: {
      const user = new User(action.user);
      return user;
    }
    case authActionTypes.AUTH_LOGOUT_SUCCESS: {
      return new User();
    }
    default: {
      return state;
    }
  }
}

export function userListReducer(state = userListInitialState, action) {
  switch (action.type) {
    case userActionTypes.USER_FETCH_ALL_SUCCESS: {
      const newUsersArray = action.users.map(user => new User(user));
      const newUsersList = new List(newUsersArray);
      return state.merge({ users: newUsersList });
    }
    case userActionTypes.USER_TYPES_FETCH_ALL_SUCCESS: {
      const newUserTypesArray = action.userTypes.map(
        userType =>
          new UserType({
            id: userType.id,
            description: userType.description,
          })
      );
      const newUserList = new List(newUserTypesArray);
      return state.merge({ userTypes: newUserList });
    }
    default: {
      return state;
    }
  }
}

export function userInviteReducer(state = UserInviteInitialState, action) {
  switch (action.type) {
    case userActionTypes.USER_INVITE_FORM_SUBMIT: {
      return new UserInvite({
        isSecond: true,
        hasSecond: action.notification,
        firstName: action.firstName,
        lastName: action.lastName,
      });
    }
    case userActionTypes.USER_INVITE_SUCCESS_CLOSE: {
      return new UserInvite({
        isSecond: false,
        hasSecond: action.notification,
        firstName: null,
        lastName: null,
      });
    }
    default: {
      return state;
    }
  }
}
